// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v3.12.4
// source: bgsearch/bgsearch_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";

export const protobufPackage = "biggeo.protobuf";

export enum ComplianceLevel {
  COMPLIANCE_LEVEL_UNSPECIFIED = 0,
  COMPLIANCE_LEVEL_BIGGEO = 1,
  COMPLIANCE_LEVEL_OGC = 2,
  UNRECOGNIZED = -1,
}

export function complianceLevelFromJSON(object: any): ComplianceLevel {
  switch (object) {
    case 0:
    case "COMPLIANCE_LEVEL_UNSPECIFIED":
      return ComplianceLevel.COMPLIANCE_LEVEL_UNSPECIFIED;
    case 1:
    case "COMPLIANCE_LEVEL_BIGGEO":
      return ComplianceLevel.COMPLIANCE_LEVEL_BIGGEO;
    case 2:
    case "COMPLIANCE_LEVEL_OGC":
      return ComplianceLevel.COMPLIANCE_LEVEL_OGC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ComplianceLevel.UNRECOGNIZED;
  }
}

export function complianceLevelToJSON(object: ComplianceLevel): string {
  switch (object) {
    case ComplianceLevel.COMPLIANCE_LEVEL_UNSPECIFIED:
      return "COMPLIANCE_LEVEL_UNSPECIFIED";
    case ComplianceLevel.COMPLIANCE_LEVEL_BIGGEO:
      return "COMPLIANCE_LEVEL_BIGGEO";
    case ComplianceLevel.COMPLIANCE_LEVEL_OGC:
      return "COMPLIANCE_LEVEL_OGC";
    case ComplianceLevel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum WindingOrder {
  WINDING_ORDER_UNSPECIFIED = 0,
  WINDING_ORDER_LEFT_INSIDE = 1,
  WINDING_ORDER_RIGHT_INSIDE = 2,
  WINDING_ORDER_SMALLER_GEOMETRY = 3,
  UNRECOGNIZED = -1,
}

export function windingOrderFromJSON(object: any): WindingOrder {
  switch (object) {
    case 0:
    case "WINDING_ORDER_UNSPECIFIED":
      return WindingOrder.WINDING_ORDER_UNSPECIFIED;
    case 1:
    case "WINDING_ORDER_LEFT_INSIDE":
      return WindingOrder.WINDING_ORDER_LEFT_INSIDE;
    case 2:
    case "WINDING_ORDER_RIGHT_INSIDE":
      return WindingOrder.WINDING_ORDER_RIGHT_INSIDE;
    case 3:
    case "WINDING_ORDER_SMALLER_GEOMETRY":
      return WindingOrder.WINDING_ORDER_SMALLER_GEOMETRY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WindingOrder.UNRECOGNIZED;
  }
}

export function windingOrderToJSON(object: WindingOrder): string {
  switch (object) {
    case WindingOrder.WINDING_ORDER_UNSPECIFIED:
      return "WINDING_ORDER_UNSPECIFIED";
    case WindingOrder.WINDING_ORDER_LEFT_INSIDE:
      return "WINDING_ORDER_LEFT_INSIDE";
    case WindingOrder.WINDING_ORDER_RIGHT_INSIDE:
      return "WINDING_ORDER_RIGHT_INSIDE";
    case WindingOrder.WINDING_ORDER_SMALLER_GEOMETRY:
      return "WINDING_ORDER_SMALLER_GEOMETRY";
    case WindingOrder.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum IndexType {
  INDEX_TYPE_UNSPECIFIED = 0,
  INDEX_TYPE_PER_NODE = 1,
  INDEX_TYPE_ULL = 2,
  UNRECOGNIZED = -1,
}

export function indexTypeFromJSON(object: any): IndexType {
  switch (object) {
    case 0:
    case "INDEX_TYPE_UNSPECIFIED":
      return IndexType.INDEX_TYPE_UNSPECIFIED;
    case 1:
    case "INDEX_TYPE_PER_NODE":
      return IndexType.INDEX_TYPE_PER_NODE;
    case 2:
    case "INDEX_TYPE_ULL":
      return IndexType.INDEX_TYPE_ULL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IndexType.UNRECOGNIZED;
  }
}

export function indexTypeToJSON(object: IndexType): string {
  switch (object) {
    case IndexType.INDEX_TYPE_UNSPECIFIED:
      return "INDEX_TYPE_UNSPECIFIED";
    case IndexType.INDEX_TYPE_PER_NODE:
      return "INDEX_TYPE_PER_NODE";
    case IndexType.INDEX_TYPE_ULL:
      return "INDEX_TYPE_ULL";
    case IndexType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum IDType {
  ID_TYPE_UNSPECIFIED = 0,
  ID_TYPE_PROVIDED_U64 = 1,
  /**
   * ID_TYPE_AUTO_INC - ID_TYPE_PROVIDED_UUID = 2;
   * ID_TYPE_ASSIGNED_UUID = 3;
   */
  ID_TYPE_AUTO_INC = 4,
  ID_TYPE_PROVIDED_STR = 5,
  UNRECOGNIZED = -1,
}

export function iDTypeFromJSON(object: any): IDType {
  switch (object) {
    case 0:
    case "ID_TYPE_UNSPECIFIED":
      return IDType.ID_TYPE_UNSPECIFIED;
    case 1:
    case "ID_TYPE_PROVIDED_U64":
      return IDType.ID_TYPE_PROVIDED_U64;
    case 4:
    case "ID_TYPE_AUTO_INC":
      return IDType.ID_TYPE_AUTO_INC;
    case 5:
    case "ID_TYPE_PROVIDED_STR":
      return IDType.ID_TYPE_PROVIDED_STR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IDType.UNRECOGNIZED;
  }
}

export function iDTypeToJSON(object: IDType): string {
  switch (object) {
    case IDType.ID_TYPE_UNSPECIFIED:
      return "ID_TYPE_UNSPECIFIED";
    case IDType.ID_TYPE_PROVIDED_U64:
      return "ID_TYPE_PROVIDED_U64";
    case IDType.ID_TYPE_AUTO_INC:
      return "ID_TYPE_AUTO_INC";
    case IDType.ID_TYPE_PROVIDED_STR:
      return "ID_TYPE_PROVIDED_STR";
    case IDType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface LatLng {
  latitude: number;
  longitude: number;
}

/** LineStrips can't have fewer than 2 points */
export interface LineStrip {
  points: LatLng[];
}

/**
 * Rings can't be self-intersecting
 * Rings are implicitly closed (the first and last point are implicitly connected)
 * Rings can't have fewer than 3 points
 * Rings can't have duplicate points
 */
export interface Ring {
  points: LatLng[];
}

/**
 * Vertices should be specified in an order such that the
 * left of the edge denotes the inside. For small polygons,
 * this means the exterior ring should be specified in
 * counter-clockwise order, and holes should be clockwise.
 *
 * Inner rings must be contained by the outer ring
 * Inner rings can't intersect each other
 */
export interface Polygon {
  /** polygon outer ring - must be counter-clockwise */
  outer:
    | Ring
    | undefined;
  /** polygons holes - they have to be clockwise */
  inners: Ring[];
}

export interface MultiPolygon {
  polygons: Polygon[];
}

export interface MultiLineStrip {
  lineStrips: LineStrip[];
}

export interface LatLngBBox {
  topLeft: LatLng | undefined;
  bottomRight: LatLng | undefined;
}

export interface IndexableGeometry {
  point?: LatLng | undefined;
  lineStrip?: LineStrip | undefined;
  polygon?:
    | Polygon
    | undefined;
  /** MultiPoint multi_point = 4; */
  multiLineStrip?:
    | MultiLineStrip
    | undefined;
  /** MultiGeometry multi_geometry = 7; */
  multiPolygon?: MultiPolygon | undefined;
}

export interface GeometryID {
  uint64?:
    | Long
    | undefined;
  /** string uuid = 2; */
  string?: string | undefined;
}

/** TODO is this the best way to do this? */
export interface Payload {
  data: Uint8Array;
}

export interface ComplianceArgs {
  level: ComplianceLevel;
  windingOrder: WindingOrder;
}

export interface IndexedGeometry {
  id: GeometryID | undefined;
  geometry: IndexableGeometry | undefined;
  payload?: Payload | undefined;
  compliance: ComplianceArgs | undefined;
}

export interface DGGSIndex {
  index: string;
}

export interface Bounds {
  min: number;
  max: number;
}

export interface ViewBox {
  latBounds: Bounds | undefined;
  lngBounds: Bounds | undefined;
}

function createBaseLatLng(): LatLng {
  return { latitude: 0, longitude: 0 };
}

export const LatLng: MessageFns<LatLng> = {
  encode(message: LatLng, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latitude !== 0) {
      writer.uint32(9).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LatLng {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLatLng();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LatLng {
    return {
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
    };
  },

  toJSON(message: LatLng): unknown {
    const obj: any = {};
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LatLng>, I>>(base?: I): LatLng {
    return LatLng.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LatLng>, I>>(object: I): LatLng {
    const message = createBaseLatLng();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    return message;
  },
};

function createBaseLineStrip(): LineStrip {
  return { points: [] };
}

export const LineStrip: MessageFns<LineStrip> = {
  encode(message: LineStrip, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.points) {
      LatLng.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LineStrip {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLineStrip();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.points.push(LatLng.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LineStrip {
    return {
      points: globalThis.Array.isArray(object?.points) ? object.points.map((e: any) => LatLng.fromJSON(e)) : [],
    };
  },

  toJSON(message: LineStrip): unknown {
    const obj: any = {};
    if (message.points?.length) {
      obj.points = message.points.map((e) => LatLng.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LineStrip>, I>>(base?: I): LineStrip {
    return LineStrip.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LineStrip>, I>>(object: I): LineStrip {
    const message = createBaseLineStrip();
    message.points = object.points?.map((e) => LatLng.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRing(): Ring {
  return { points: [] };
}

export const Ring: MessageFns<Ring> = {
  encode(message: Ring, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.points) {
      LatLng.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Ring {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.points.push(LatLng.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Ring {
    return {
      points: globalThis.Array.isArray(object?.points) ? object.points.map((e: any) => LatLng.fromJSON(e)) : [],
    };
  },

  toJSON(message: Ring): unknown {
    const obj: any = {};
    if (message.points?.length) {
      obj.points = message.points.map((e) => LatLng.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Ring>, I>>(base?: I): Ring {
    return Ring.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Ring>, I>>(object: I): Ring {
    const message = createBaseRing();
    message.points = object.points?.map((e) => LatLng.fromPartial(e)) || [];
    return message;
  },
};

function createBasePolygon(): Polygon {
  return { outer: undefined, inners: [] };
}

export const Polygon: MessageFns<Polygon> = {
  encode(message: Polygon, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outer !== undefined) {
      Ring.encode(message.outer, writer.uint32(10).fork()).join();
    }
    for (const v of message.inners) {
      Ring.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Polygon {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePolygon();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.outer = Ring.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.inners.push(Ring.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Polygon {
    return {
      outer: isSet(object.outer) ? Ring.fromJSON(object.outer) : undefined,
      inners: globalThis.Array.isArray(object?.inners) ? object.inners.map((e: any) => Ring.fromJSON(e)) : [],
    };
  },

  toJSON(message: Polygon): unknown {
    const obj: any = {};
    if (message.outer !== undefined) {
      obj.outer = Ring.toJSON(message.outer);
    }
    if (message.inners?.length) {
      obj.inners = message.inners.map((e) => Ring.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Polygon>, I>>(base?: I): Polygon {
    return Polygon.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Polygon>, I>>(object: I): Polygon {
    const message = createBasePolygon();
    message.outer = (object.outer !== undefined && object.outer !== null) ? Ring.fromPartial(object.outer) : undefined;
    message.inners = object.inners?.map((e) => Ring.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMultiPolygon(): MultiPolygon {
  return { polygons: [] };
}

export const MultiPolygon: MessageFns<MultiPolygon> = {
  encode(message: MultiPolygon, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.polygons) {
      Polygon.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultiPolygon {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiPolygon();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.polygons.push(Polygon.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultiPolygon {
    return {
      polygons: globalThis.Array.isArray(object?.polygons) ? object.polygons.map((e: any) => Polygon.fromJSON(e)) : [],
    };
  },

  toJSON(message: MultiPolygon): unknown {
    const obj: any = {};
    if (message.polygons?.length) {
      obj.polygons = message.polygons.map((e) => Polygon.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultiPolygon>, I>>(base?: I): MultiPolygon {
    return MultiPolygon.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultiPolygon>, I>>(object: I): MultiPolygon {
    const message = createBaseMultiPolygon();
    message.polygons = object.polygons?.map((e) => Polygon.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMultiLineStrip(): MultiLineStrip {
  return { lineStrips: [] };
}

export const MultiLineStrip: MessageFns<MultiLineStrip> = {
  encode(message: MultiLineStrip, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.lineStrips) {
      LineStrip.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultiLineStrip {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiLineStrip();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lineStrips.push(LineStrip.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultiLineStrip {
    return {
      lineStrips: globalThis.Array.isArray(object?.lineStrips)
        ? object.lineStrips.map((e: any) => LineStrip.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MultiLineStrip): unknown {
    const obj: any = {};
    if (message.lineStrips?.length) {
      obj.lineStrips = message.lineStrips.map((e) => LineStrip.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultiLineStrip>, I>>(base?: I): MultiLineStrip {
    return MultiLineStrip.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultiLineStrip>, I>>(object: I): MultiLineStrip {
    const message = createBaseMultiLineStrip();
    message.lineStrips = object.lineStrips?.map((e) => LineStrip.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLatLngBBox(): LatLngBBox {
  return { topLeft: undefined, bottomRight: undefined };
}

export const LatLngBBox: MessageFns<LatLngBBox> = {
  encode(message: LatLngBBox, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.topLeft !== undefined) {
      LatLng.encode(message.topLeft, writer.uint32(10).fork()).join();
    }
    if (message.bottomRight !== undefined) {
      LatLng.encode(message.bottomRight, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LatLngBBox {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLatLngBBox();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topLeft = LatLng.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.bottomRight = LatLng.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LatLngBBox {
    return {
      topLeft: isSet(object.topLeft) ? LatLng.fromJSON(object.topLeft) : undefined,
      bottomRight: isSet(object.bottomRight) ? LatLng.fromJSON(object.bottomRight) : undefined,
    };
  },

  toJSON(message: LatLngBBox): unknown {
    const obj: any = {};
    if (message.topLeft !== undefined) {
      obj.topLeft = LatLng.toJSON(message.topLeft);
    }
    if (message.bottomRight !== undefined) {
      obj.bottomRight = LatLng.toJSON(message.bottomRight);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LatLngBBox>, I>>(base?: I): LatLngBBox {
    return LatLngBBox.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LatLngBBox>, I>>(object: I): LatLngBBox {
    const message = createBaseLatLngBBox();
    message.topLeft = (object.topLeft !== undefined && object.topLeft !== null)
      ? LatLng.fromPartial(object.topLeft)
      : undefined;
    message.bottomRight = (object.bottomRight !== undefined && object.bottomRight !== null)
      ? LatLng.fromPartial(object.bottomRight)
      : undefined;
    return message;
  },
};

function createBaseIndexableGeometry(): IndexableGeometry {
  return {
    point: undefined,
    lineStrip: undefined,
    polygon: undefined,
    multiLineStrip: undefined,
    multiPolygon: undefined,
  };
}

export const IndexableGeometry: MessageFns<IndexableGeometry> = {
  encode(message: IndexableGeometry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.point !== undefined) {
      LatLng.encode(message.point, writer.uint32(10).fork()).join();
    }
    if (message.lineStrip !== undefined) {
      LineStrip.encode(message.lineStrip, writer.uint32(18).fork()).join();
    }
    if (message.polygon !== undefined) {
      Polygon.encode(message.polygon, writer.uint32(26).fork()).join();
    }
    if (message.multiLineStrip !== undefined) {
      MultiLineStrip.encode(message.multiLineStrip, writer.uint32(42).fork()).join();
    }
    if (message.multiPolygon !== undefined) {
      MultiPolygon.encode(message.multiPolygon, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IndexableGeometry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndexableGeometry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.point = LatLng.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lineStrip = LineStrip.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.polygon = Polygon.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.multiLineStrip = MultiLineStrip.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.multiPolygon = MultiPolygon.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IndexableGeometry {
    return {
      point: isSet(object.point) ? LatLng.fromJSON(object.point) : undefined,
      lineStrip: isSet(object.lineStrip) ? LineStrip.fromJSON(object.lineStrip) : undefined,
      polygon: isSet(object.polygon) ? Polygon.fromJSON(object.polygon) : undefined,
      multiLineStrip: isSet(object.multiLineStrip) ? MultiLineStrip.fromJSON(object.multiLineStrip) : undefined,
      multiPolygon: isSet(object.multiPolygon) ? MultiPolygon.fromJSON(object.multiPolygon) : undefined,
    };
  },

  toJSON(message: IndexableGeometry): unknown {
    const obj: any = {};
    if (message.point !== undefined) {
      obj.point = LatLng.toJSON(message.point);
    }
    if (message.lineStrip !== undefined) {
      obj.lineStrip = LineStrip.toJSON(message.lineStrip);
    }
    if (message.polygon !== undefined) {
      obj.polygon = Polygon.toJSON(message.polygon);
    }
    if (message.multiLineStrip !== undefined) {
      obj.multiLineStrip = MultiLineStrip.toJSON(message.multiLineStrip);
    }
    if (message.multiPolygon !== undefined) {
      obj.multiPolygon = MultiPolygon.toJSON(message.multiPolygon);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IndexableGeometry>, I>>(base?: I): IndexableGeometry {
    return IndexableGeometry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IndexableGeometry>, I>>(object: I): IndexableGeometry {
    const message = createBaseIndexableGeometry();
    message.point = (object.point !== undefined && object.point !== null)
      ? LatLng.fromPartial(object.point)
      : undefined;
    message.lineStrip = (object.lineStrip !== undefined && object.lineStrip !== null)
      ? LineStrip.fromPartial(object.lineStrip)
      : undefined;
    message.polygon = (object.polygon !== undefined && object.polygon !== null)
      ? Polygon.fromPartial(object.polygon)
      : undefined;
    message.multiLineStrip = (object.multiLineStrip !== undefined && object.multiLineStrip !== null)
      ? MultiLineStrip.fromPartial(object.multiLineStrip)
      : undefined;
    message.multiPolygon = (object.multiPolygon !== undefined && object.multiPolygon !== null)
      ? MultiPolygon.fromPartial(object.multiPolygon)
      : undefined;
    return message;
  },
};

function createBaseGeometryID(): GeometryID {
  return { uint64: undefined, string: undefined };
}

export const GeometryID: MessageFns<GeometryID> = {
  encode(message: GeometryID, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uint64 !== undefined) {
      writer.uint32(8).uint64(message.uint64.toString());
    }
    if (message.string !== undefined) {
      writer.uint32(26).string(message.string);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GeometryID {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeometryID();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.uint64 = Long.fromString(reader.uint64().toString(), true);
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.string = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GeometryID {
    return {
      uint64: isSet(object.uint64) ? Long.fromValue(object.uint64) : undefined,
      string: isSet(object.string) ? globalThis.String(object.string) : undefined,
    };
  },

  toJSON(message: GeometryID): unknown {
    const obj: any = {};
    if (message.uint64 !== undefined) {
      obj.uint64 = (message.uint64 || Long.UZERO).toString();
    }
    if (message.string !== undefined) {
      obj.string = message.string;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GeometryID>, I>>(base?: I): GeometryID {
    return GeometryID.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeometryID>, I>>(object: I): GeometryID {
    const message = createBaseGeometryID();
    message.uint64 = (object.uint64 !== undefined && object.uint64 !== null)
      ? Long.fromValue(object.uint64)
      : undefined;
    message.string = object.string ?? undefined;
    return message;
  },
};

function createBasePayload(): Payload {
  return { data: new Uint8Array(0) };
}

export const Payload: MessageFns<Payload> = {
  encode(message: Payload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Payload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Payload {
    return { data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0) };
  },

  toJSON(message: Payload): unknown {
    const obj: any = {};
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Payload>, I>>(base?: I): Payload {
    return Payload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Payload>, I>>(object: I): Payload {
    const message = createBasePayload();
    message.data = object.data ?? new Uint8Array(0);
    return message;
  },
};

function createBaseComplianceArgs(): ComplianceArgs {
  return { level: 0, windingOrder: 0 };
}

export const ComplianceArgs: MessageFns<ComplianceArgs> = {
  encode(message: ComplianceArgs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.level !== 0) {
      writer.uint32(8).int32(message.level);
    }
    if (message.windingOrder !== 0) {
      writer.uint32(16).int32(message.windingOrder);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComplianceArgs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComplianceArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.windingOrder = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ComplianceArgs {
    return {
      level: isSet(object.level) ? complianceLevelFromJSON(object.level) : 0,
      windingOrder: isSet(object.windingOrder) ? windingOrderFromJSON(object.windingOrder) : 0,
    };
  },

  toJSON(message: ComplianceArgs): unknown {
    const obj: any = {};
    if (message.level !== 0) {
      obj.level = complianceLevelToJSON(message.level);
    }
    if (message.windingOrder !== 0) {
      obj.windingOrder = windingOrderToJSON(message.windingOrder);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComplianceArgs>, I>>(base?: I): ComplianceArgs {
    return ComplianceArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComplianceArgs>, I>>(object: I): ComplianceArgs {
    const message = createBaseComplianceArgs();
    message.level = object.level ?? 0;
    message.windingOrder = object.windingOrder ?? 0;
    return message;
  },
};

function createBaseIndexedGeometry(): IndexedGeometry {
  return { id: undefined, geometry: undefined, payload: undefined, compliance: undefined };
}

export const IndexedGeometry: MessageFns<IndexedGeometry> = {
  encode(message: IndexedGeometry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      GeometryID.encode(message.id, writer.uint32(10).fork()).join();
    }
    if (message.geometry !== undefined) {
      IndexableGeometry.encode(message.geometry, writer.uint32(18).fork()).join();
    }
    if (message.payload !== undefined) {
      Payload.encode(message.payload, writer.uint32(26).fork()).join();
    }
    if (message.compliance !== undefined) {
      ComplianceArgs.encode(message.compliance, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IndexedGeometry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndexedGeometry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = GeometryID.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.geometry = IndexableGeometry.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.payload = Payload.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.compliance = ComplianceArgs.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IndexedGeometry {
    return {
      id: isSet(object.id) ? GeometryID.fromJSON(object.id) : undefined,
      geometry: isSet(object.geometry) ? IndexableGeometry.fromJSON(object.geometry) : undefined,
      payload: isSet(object.payload) ? Payload.fromJSON(object.payload) : undefined,
      compliance: isSet(object.compliance) ? ComplianceArgs.fromJSON(object.compliance) : undefined,
    };
  },

  toJSON(message: IndexedGeometry): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = GeometryID.toJSON(message.id);
    }
    if (message.geometry !== undefined) {
      obj.geometry = IndexableGeometry.toJSON(message.geometry);
    }
    if (message.payload !== undefined) {
      obj.payload = Payload.toJSON(message.payload);
    }
    if (message.compliance !== undefined) {
      obj.compliance = ComplianceArgs.toJSON(message.compliance);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IndexedGeometry>, I>>(base?: I): IndexedGeometry {
    return IndexedGeometry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IndexedGeometry>, I>>(object: I): IndexedGeometry {
    const message = createBaseIndexedGeometry();
    message.id = (object.id !== undefined && object.id !== null) ? GeometryID.fromPartial(object.id) : undefined;
    message.geometry = (object.geometry !== undefined && object.geometry !== null)
      ? IndexableGeometry.fromPartial(object.geometry)
      : undefined;
    message.payload = (object.payload !== undefined && object.payload !== null)
      ? Payload.fromPartial(object.payload)
      : undefined;
    message.compliance = (object.compliance !== undefined && object.compliance !== null)
      ? ComplianceArgs.fromPartial(object.compliance)
      : undefined;
    return message;
  },
};

function createBaseDGGSIndex(): DGGSIndex {
  return { index: "" };
}

export const DGGSIndex: MessageFns<DGGSIndex> = {
  encode(message: DGGSIndex, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.index !== "") {
      writer.uint32(10).string(message.index);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DGGSIndex {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDGGSIndex();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.index = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DGGSIndex {
    return { index: isSet(object.index) ? globalThis.String(object.index) : "" };
  },

  toJSON(message: DGGSIndex): unknown {
    const obj: any = {};
    if (message.index !== "") {
      obj.index = message.index;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DGGSIndex>, I>>(base?: I): DGGSIndex {
    return DGGSIndex.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DGGSIndex>, I>>(object: I): DGGSIndex {
    const message = createBaseDGGSIndex();
    message.index = object.index ?? "";
    return message;
  },
};

function createBaseBounds(): Bounds {
  return { min: 0, max: 0 };
}

export const Bounds: MessageFns<Bounds> = {
  encode(message: Bounds, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== 0) {
      writer.uint32(9).double(message.min);
    }
    if (message.max !== 0) {
      writer.uint32(17).double(message.max);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Bounds {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBounds();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.min = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.max = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Bounds {
    return {
      min: isSet(object.min) ? globalThis.Number(object.min) : 0,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
    };
  },

  toJSON(message: Bounds): unknown {
    const obj: any = {};
    if (message.min !== 0) {
      obj.min = message.min;
    }
    if (message.max !== 0) {
      obj.max = message.max;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Bounds>, I>>(base?: I): Bounds {
    return Bounds.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Bounds>, I>>(object: I): Bounds {
    const message = createBaseBounds();
    message.min = object.min ?? 0;
    message.max = object.max ?? 0;
    return message;
  },
};

function createBaseViewBox(): ViewBox {
  return { latBounds: undefined, lngBounds: undefined };
}

export const ViewBox: MessageFns<ViewBox> = {
  encode(message: ViewBox, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latBounds !== undefined) {
      Bounds.encode(message.latBounds, writer.uint32(10).fork()).join();
    }
    if (message.lngBounds !== undefined) {
      Bounds.encode(message.lngBounds, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ViewBox {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseViewBox();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.latBounds = Bounds.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lngBounds = Bounds.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ViewBox {
    return {
      latBounds: isSet(object.latBounds) ? Bounds.fromJSON(object.latBounds) : undefined,
      lngBounds: isSet(object.lngBounds) ? Bounds.fromJSON(object.lngBounds) : undefined,
    };
  },

  toJSON(message: ViewBox): unknown {
    const obj: any = {};
    if (message.latBounds !== undefined) {
      obj.latBounds = Bounds.toJSON(message.latBounds);
    }
    if (message.lngBounds !== undefined) {
      obj.lngBounds = Bounds.toJSON(message.lngBounds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ViewBox>, I>>(base?: I): ViewBox {
    return ViewBox.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ViewBox>, I>>(object: I): ViewBox {
    const message = createBaseViewBox();
    message.latBounds = (object.latBounds !== undefined && object.latBounds !== null)
      ? Bounds.fromPartial(object.latBounds)
      : undefined;
    message.lngBounds = (object.lngBounds !== undefined && object.lngBounds !== null)
      ? Bounds.fromPartial(object.lngBounds)
      : undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
